import { render, staticRenderFns } from "./SilenceAlertsModal.vue?vue&type=template&id=1213e9a6&scoped=true&"
import script from "./SilenceAlertsModal.vue?vue&type=script&lang=js&"
export * from "./SilenceAlertsModal.vue?vue&type=script&lang=js&"
import style0 from "./SilenceAlertsModal.vue?vue&type=style&index=0&id=1213e9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213e9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1213e9a6')) {
      api.createRecord('1213e9a6', component.options)
    } else {
      api.reload('1213e9a6', component.options)
    }
    module.hot.accept("./SilenceAlertsModal.vue?vue&type=template&id=1213e9a6&scoped=true&", function () {
      api.rerender('1213e9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/SilenceAlertsModal.vue"
export default component.exports